import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

/**
 * EmptyState — Presentation Component
 *
 * Displayed when a search/filter produces zero results.
 * Shows contextual message and action buttons based on what's active.
 */
@Component({
  selector: 'app-empty-state',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './empty-state.component.html',
  styleUrl: './empty-state.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyStateComponent {
  /** Current search term (to show in the "no results for X" message) */
  @Input() searchTerm = '';

  /** Whether any filters are currently active */
  @Input() hasActiveFilters = false;

  /** Emitted when user clicks "Clear Search" */
  @Output() clearSearch = new EventEmitter<void>();

  /** Emitted when user clicks "Clear Filters" */
  @Output() clearFilters = new EventEmitter<void>();

  get hasSearch(): boolean {
    return this.searchTerm.trim().length > 0;
  }
}
